// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing058({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/058/25010601.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/058/25010602.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/058/25010603.gif`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/teal/getBenefitButton.jpg`}
      qTitleColor="#016867"
      qOptionColor="teal"
      formFieldColor="white"
      companyName="본원"
      privacyMessage="개인정보수집에 동의하시는 분만 '혜택받기'버튼을 눌러주세요."
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
      eventDates={true}
    />
  );
}

export default Randing058;
